module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-vcentered is-centered has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n            Temperature\n          ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n            Temperature & Humidity in my home\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('router-link', {
    staticClass: "button is-white",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Temperature")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-white",
    attrs: {
      "to": "/humidity/day"
    }
  }, [_vm._v("Humidity")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-narrow"
  }, [_c('img', {
    staticClass: "app-logo",
    attrs: {
      "src": require("../assets/logo.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-697ed617","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = 374
// module chunks = 1